module.exports = __webpack_public_path__ + "img/21_9.ceabd6ea.png";